<template>
  <el-dialog :title="`课后考试配置 - ${videoName}`" :visible.sync="visible" width="720px"
             top="5vh"
             append-to-body
             :close-on-click-modal="false">
    <div v-loading="loading">
      <!-- 与页面上那套「是否考试」不是一回事，不写清楚运营一定会混 -->
      <el-alert type="info" :closable="false" class="mb10">
        这是<b>课后考试</b>（REQ-2026-403009）：按<b>视频课时</b>各配一套题，学员看完这个课时才能考。
        课程编辑页里那套「是否考试」是旧的<b>课程考试</b>，两者并存、互不影响。
      </el-alert>

      <el-form ref="form" :model="form" label-width="150px" size="small">
        <el-form-item label="是否开启考试：">
          <el-radio-group v-model="form.isEnabled">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">不开启</el-radio>
          </el-radio-group>
        </el-form-item>

        <template v-if="form.isEnabled === 1">
          <el-form-item label="关联试卷：">
            <el-select v-model="form.topicClassificationId" placeholder="请选择题库分类" clearable
                       filterable
                       style="width:260px">
              <el-option v-for="item in classOptions" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
            <span class="tip">只列「课程考试」用途的题库分类</span>
          </el-form-item>
          <el-form-item label="抽题数量：">
            <el-input-number v-model="form.topicNum" :min="1" :max="200"
                             controls-position="right"
                             style="width:130px" />
            <span class="tip">题库题数不足时按实际题数出卷</span>
          </el-form-item>
          <el-form-item label="单题分值：">
            <el-input-number v-model="form.scorePerTopic" :min="0.5" :max="100"
                             :precision="2" :step="1"
                             controls-position="right" style="width:130px" />
            <span class="tip">总分 {{ totalScore }} 分</span>
          </el-form-item>
          <el-form-item label="达标分：">
            <el-input-number v-model="form.passScore" :min="0" :max="totalScore"
                             :precision="2"
                             controls-position="right" style="width:130px" />
            <span class="tip">不能大于总分</span>
          </el-form-item>
          <el-form-item label="考试学分：">
            <el-input-number v-model="form.credit" :min="0" :precision="2"
                             controls-position="right"
                             style="width:130px" />
            <span class="tip">本期只记录，不参与计算</span>
          </el-form-item>
          <el-form-item label="考试时长：">
            <el-input-number v-model="form.durationMinute" :min="0" :max="600"
                             controls-position="right"
                             style="width:130px" />
            <span class="tip">分钟；填 0 = 不限时。倒计时以服务端时间为准</span>
          </el-form-item>
          <el-form-item label="视频完成阈值：">
            <el-input-number v-model="form.completeRatio" :min="0.1" :max="1"
                             :precision="2" :step="0.05"
                             controls-position="right" style="width:130px" />
            <span class="tip">播放位置达到「时长 × 该值」即算看完，默认 0.95</span>
          </el-form-item>
          <el-form-item label="看完自动弹窗：">
            <el-switch v-model="form.autoPopup" :active-value="1" :inactive-value="0" />
            <span class="tip">同一课时只弹一次；关掉弹窗不扣考试次数</span>
          </el-form-item>
          <el-form-item label="考试次数：">
            <el-radio-group v-model="form.attemptMode">
              <el-radio :label="1">仅 1 次</el-radio>
              <el-radio :label="2">限定次数</el-radio>
              <el-radio :label="3">不限</el-radio>
            </el-radio-group>
            <el-input-number v-if="form.attemptMode === 2" v-model="form.attemptLimit" :min="1"
                             :max="99"
                             controls-position="right" style="width:110px" />
          </el-form-item>
          <el-form-item label="通过后可重考：">
            <el-switch v-model="form.retryAfterPass" :active-value="1" :inactive-value="0" />
          </el-form-item>
          <el-form-item label="最终成绩取：">
            <el-select v-model="form.finalScoreRule" style="width:150px">
              <el-option label="最高分" :value="1" />
              <el-option label="最近一次" :value="2" />
              <el-option label="首次" :value="3" />
            </el-select>
            <span class="tip">改这项不会改动历史答卷</span>
          </el-form-item>
          <el-form-item label="答案解析：">
            <el-select v-model="form.resolutionPolicy" style="width:170px">
              <el-option label="交卷后立即可看" :value="1" />
              <el-option label="通过后可看" :value="2" />
              <el-option label="次数用完后可看" :value="3" />
              <el-option label="指定时间后可看" :value="4" />
              <el-option label="永不可看" :value="5" />
            </el-select>
            <el-date-picker v-if="form.resolutionPolicy === 4" v-model="form.resolutionOpenTime" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="开放时间" style="width:200px" />
            <span class="tip">未开放时接口不下发正确答案，抓包也拿不到</span>
          </el-form-item>
          <el-form-item label="成绩公布：">
            <el-select v-model="form.scorePublishPolicy" style="width:150px">
              <el-option label="交卷即公布" :value="1" />
              <el-option label="指定时间公布" :value="2" />
            </el-select>
            <el-date-picker v-if="form.scorePublishPolicy === 2" v-model="form.scorePublishTime" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="公布时间" style="width:200px" />
          </el-form-item>
          <el-form-item label="题目/选项随机：">
            <el-switch v-model="form.topicRandom" :active-value="1" :inactive-value="0" active-text="题目随机" />
            <el-switch v-model="form.optionRandom" :active-value="1" :inactive-value="0"
                       active-text="选项随机"
                       class="ml10" />
          </el-form-item>
          <!-- 发的是学分，不是积分（ISSUE-2026-392021）；接口字段仍叫 pointsTiers，不改 -->
          <el-form-item label="学分档位：">
            <div v-for="(t, i) in form.tiers" :key="i" class="tier-row">
              <span class="tier-label">{{ t.label }}</span>
              <el-input-number v-model="t.points" :min="0" :max="99999"
                               controls-position="right"
                               style="width:120px" />
              <span class="tip">分</span>
            </div>
            <div class="tip">边界含下限：正好 90 分算「90-99」档；填 0 表示该档不发学分</div>
          </el-form-item>
        </template>
      </el-form>

      <div v-if="form.id" class="version-tip">
        当前规则版本 <b>v{{ form.ruleVersion }}</b>。改动判分/次数/解析/学分相关项会升一个版本：
        已在考试中的答卷仍按原版本结算，<b>学分额度也按版本重新计算一轮</b>。
      </div>
    </div>
    <span slot="footer">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" type="primary" :loading="saving" @click="submit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import courseExamApi from '@/api/course/courseExam'
import courseTopicClassificationApi from '@/api/course/courseTopicClassification'

/** 课程考试用途的题库分类（course_topic_classification.purposeType） */
const PURPOSE_COURSE_EXAM = 3

/** 学分四档：100 / 90-99 / 80-89 / 80 以下，边界含下限 */
const TIER_TEMPLATE = [
  { min: 100, label: '满分（100）' },
  { min: 90, label: '90 - 99' },
  { min: 80, label: '80 - 89' },
  { min: 0, label: '80 以下' }
]

/**
 * 课后考试配置弹窗（REQ-2026-403009，原型 4）
 *
 * 挂在**章节（视频课时）列表**的每一行，而不是课程编辑表单里：任务书 §0 第 2 条定的是
 * 「每个视频课时各绑一套题」，课程级的表单放不下按课时区分的配置。
 * 另外课程编辑页本来就有一套旧「课程考试」的配置，再加一套同名的在同一个表单里必然混。
 */
export default {
  name: 'AfterClassExamDialog',
  data() {
    return {
      visible: false,
      loading: false,
      saving: false,
      videoName: '',
      classOptions: [],
      form: this.emptyForm()
    }
  },
  computed: {
    totalScore() {
      const n = Number(this.form.topicNum) || 0
      const s = Number(this.form.scorePerTopic) || 0
      return Math.round(n * s * 100) / 100
    }
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        subjectId: null,
        videoId: null,
        topicClassificationId: null,
        isEnabled: 0,
        topicNum: 10,
        scorePerTopic: 10,
        passScore: 60,
        credit: null,
        durationMinute: 30,
        completeRatio: 0.95,
        autoPopup: 1,
        attemptMode: 1,
        attemptLimit: null,
        retryAfterPass: 0,
        finalScoreRule: 1,
        resolutionPolicy: 5,
        resolutionOpenTime: null,
        scorePublishPolicy: 1,
        scorePublishTime: null,
        topicRandom: 0,
        optionRandom: 0,
        ruleVersion: 1,
        tiers: TIER_TEMPLATE.map(t => ({ ...t, points: 0 }))
      }
    },
    /** 由章节列表调用 */
    open(row, subjectId) {
      this.visible = true
      this.videoName = row.name || ''
      this.form = this.emptyForm()
      this.form.subjectId = subjectId
      this.form.videoId = row.id
      this.loading = true
      courseTopicClassificationApi.fetchList({ purposeType: PURPOSE_COURSE_EXAM, pageNo: 1, pageSize: 200 })
        .then(({ data }) => {
          this.classOptions = (data && data.list) || []
        })
      courseExamApi.fetchConfig(row.id).then(({ data }) => {
        if (data) {
          this.fill(data)
        }
      }).finally(() => { this.loading = false })
    },
    fill(data) {
      const tiers = TIER_TEMPLATE.map(t => ({ ...t, points: 0 }))
      try {
        const parsed = data.pointsTiers ? JSON.parse(data.pointsTiers) : []
        parsed.forEach(p => {
          const hit = tiers.find(t => Number(t.min) === Number(p.min))
          if (hit) hit.points = Number(p.points) || 0
        })
      } catch (e) {
        // 档位存坏了不要让整个弹窗打不开：按全 0 显示，运营重填一次即可
        this.$message.warning('学分档位配置解析失败，已按 0 显示，请重新填写')
      }
      this.form = { ...this.form, ...data, tiers }
    },
    submit() {
      if (this.form.isEnabled === 1) {
        if (!this.form.topicClassificationId) {
          this.$message.warning('请选择关联试卷')
          return
        }
        if (Number(this.form.passScore) > this.totalScore) {
          this.$message.warning('达标分不能大于总分 ' + this.totalScore)
          return
        }
        if (this.form.attemptMode === 2 && !(Number(this.form.attemptLimit) > 0)) {
          this.$message.warning('限定次数模式下请填写次数上限')
          return
        }
        if (this.form.resolutionPolicy === 4 && !this.form.resolutionOpenTime) {
          this.$message.warning('请填写解析开放时间')
          return
        }
        if (this.form.scorePublishPolicy === 2 && !this.form.scorePublishTime) {
          this.$message.warning('请填写成绩公布时间')
          return
        }
      }
      // 端上这几条校验只是少跑一趟接口，服务端同样会校验一遍（端上的判断能被绕过）
      const payload = { ...this.form }
      payload.pointsTiers = JSON.stringify(this.form.tiers.map(t => ({ min: t.min, points: Number(t.points) || 0 })))
      delete payload.tiers
      this.saving = true
      courseExamApi.saveConfig(payload).then(res => {
        if (res && res.code === '0') {
          this.$message.success('已保存')
          this.visible = false
          this.$emit('saved')
        }
      }).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.tip {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}
.ml10 {
  margin-left: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.tier-row {
  margin-bottom: 6px;
}
.tier-label {
  display: inline-block;
  width: 96px;
  color: #606266;
}
.version-tip {
  margin-top: 6px;
  padding: 8px 12px;
  background: #fdf6ec;
  color: #E6A23C;
  font-size: 12px;
  line-height: 1.6;
  border-radius: 4px;
}
</style>
